import React, { useRef } from 'react';
import moment from 'moment';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAlertWithTitle,
  setSessionExpired,
  setSpinnerLoading,
} from '../../utility/Redux/modal';
import { useEffect } from 'react';
import { selectToken } from '../../utility/Redux/security';
import {
  selectPartyBalSelctedRowData,
  selectPartyBalSelectedStationName,
  selectPartyBalStationList,
  selectPrefix,
  selectStationId,
  selectStationName,
  selectUserType,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setPartyBalSelectedRowData,
  setPartyBalStationList,
  setpartyBalStationName,
  setreportsFromDate,
  setreportsTodate,
} from '../../utility/Redux/profile';
import { FormatNumber2 } from '../../utility/component/tools';
import PrintPartyBalanceReport from './printPartyBalanceReport';
import ReactToPrint from 'react-to-print';
import GeniusReportsDate from '../../utility/component/reportDate';
import dataToLocal from '../../utility/functions/summaryToLocal';
import IsLocalData from '../../utility/functions/ceckLocalData';
import { selectStationList, setStationList } from '../../utility/Redux/list';
import deleteWholeDatabase from '../../utility/functions/deleteWholeDatabase';
import { CallAPIPromise } from './dashboard/biiling/modal/comman';
import {
  CircleDollarSign,
  Landmark,
  MapPin,
  ReceiptIndianRupee,
  Search,
  Users,
} from 'lucide-react';
import ReportDataTable from '../../utility/component/datagrid/ReportDataTable';

const PartyBalanceReport = () => {
  const printRef = useRef();
  const UserstationId = useSelector(selectStationId);
  const userstationName = useSelector(selectStationName);
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const usertype = useSelector(selectUserType);
  const [checked, setChecked] = useState(false);
  const width = window.innerWidth / 100;
  const dispatch = useDispatch();
  const routenames = useSelector(selectPartyBalSelectedStationName);
  const selectedRowData = useSelector(selectPartyBalSelctedRowData);
  const reportsFromDate = useSelector(selectreportFromDate);
  const reportsToDate = useSelector(selectreportToDate);
  const [stname, setStName] = useState([
    usertype === 'USER' ? userstationName : routenames,
  ]);
  const [fromDate, setFromDate] = useState(reportsFromDate);
  const [fromDateFocus, setFromDateFocus] = useState(false);
 const [isRenderd,setIsRendered]=useState(false)
  const [toDate, setToDate] = useState(reportsToDate);
  const [toDateFocus, setToDateFocus] = useState(false);

  const [date, setDate] = useState(reportsFromDate);
  const [dateFocus, SetDateFocus] = useState(false);

  const [date1, setDate1] = useState(reportsToDate);
  const [dateFocus1, SetDateFocus1] = useState(false);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedRows, setSelectedRows] = useState(
    usertype === 'USER'
      ? [
          {
            CODE: UserstationId,
            STATION_NAME: userstationName,
          },
        ]
      : selectedRowData
  );
  const selectedStaionList = useSelector(selectPartyBalStationList);
  const [stationId, setstationId] = useState(
    usertype === 'USER' ? UserstationId : selectedStaionList
  );
  const stationList = useSelector(selectStationList);
  const [routeRows, setRouteRows] = useState(stationList);

  const prefix = useSelector(selectPrefix);
  const token = useSelector(selectToken);
  const windowWidth = useSelector(selectWidth);

  const columns = [
    {
      width: 70,
      headerAlign: 'center',
      align: 'center',
      field: 'ACCOUNT_NO',
      renderHeader: (params) => <div>Acc. No.</div>,
    },
    {
      width: 60,
      headerAlign: 'center',
      align: 'center',
      field: 'SID',
      renderHeader: (params) => <div>Route ID</div>,
    },
    {
      width: windowWidth > 768 ? 160 : 150,
      headerAlign: 'center',
      align: 'left',
      field: 'ADDRESS',
      renderHeader: (params) => <div>Address</div>,
    },
    {
      width: windowWidth > 768 ? 223 : 100,
      headerAlign: 'center',
      align: 'left',
      field: 'NAME',
      renderHeader: (params) => <div>Party Name</div>,
    },
    {
      width: windowWidth > 768 ? 100 : 100,
      headerAlign: 'center',
      align: 'left',
      field: 'MOBILE',
      renderHeader: (params) => <div>Mobile</div>,
    },
    // {
    //   field: 'OP_BALANCE',
    //   width: 60,
    //   headerAlign: 'center',
    //   align: 'right',

    //   renderHeader: (params) => <div>Opening</div>,
    // },
    {
      width: 120,
      headerAlign: 'center',
      align: 'right',
      field: 'DEBIT',
      renderCell: (param) => {
        if (param.value === 0) {
          return <div> {''}</div>;
        } else {
          return FormatNumber2(param.value);
        }
      },
      renderHeader: () => (
        <div
          style={{ fontSize: 12 }}
          className="whitespace-normal leading-4  text-center"
        >
          Amount Due
          <div>[Debit]</div>
        </div>
      ),
    },
    {
         width: 120,
      headerAlign: 'center',
      align: 'right',
      field: 'CREDIT',
      renderCell: (param) => {
        if (param.value === 0) {
          return <div> {''}</div>;
        } else {
          return FormatNumber2(param.value);
        }
      },
      renderHeader: () => (
        <div
          style={{ fontSize: 12 }}
          className="whitespace-normal leading-4  text-center"
        >
          {'Amount Received'}
          <div>[Collection]</div>
        </div>
      ),
    },
    {
         width: 120,
      headerAlign: 'center',
      align: 'right',
      field: 'balance',
      renderCell: (param) => {
        if (param.value === 0) {
          return <div> {''}</div>;
        } else {
          return FormatNumber2(param.value);
        }
      },
      renderHeader: () => <div>Closing Bal.</div>,
    },
    {
       width: 100,
      headerAlign: 'center',
      align: 'right',
      field: 'CREDIT_LIMIT_ALLOWED',
      renderCell: (param) => {
        if (param.value === 0) {
          return <div> {''}</div>;
        } else {
          return FormatNumber2(param.value);
        }
      },
      renderHeader: () => <div>Cr. Limit Allowed</div>,
    },
    {
       width: 100,
      headerAlign: 'center',
      field: 'CREDIT_LIMIT_PERIOD',

      renderHeader: () => <div>Cr. Limit Period</div>,
    },
    {
         width: 100,
      headerAlign: 'center',
      field: 'PAYMENT_LATE_BY_DAYS',

      renderHeader: () => <div>Payment Late(days)</div>,
    },
  ];

  const routeColumns = [
    {
      width: width * 4,
      headerAlign: 'center',
      align: 'center',
      field: 'CODE',
      renderHeader: (params) => <div>Route ID</div>,
    },
    {
      width: width * 9,
      headerAlign: 'center',
      align: 'left',
      field: 'STATION_NAME',
      renderHeader: (params) => <div>Route Name</div>,
    },
    {
      width: width * 4,
      headerAlign: 'center',
      align: 'center',
      field: '',
      renderHeader: () => <div>Select</div>,
      renderCell: (params) => {
        return (
          <input
            type="checkbox"
            checked={selectedRows.some(
              (row) => Number(row.CODE) === Number(params.row.CODE)
            )}
            onChange={(event) => handleCheckboxChange(event, params.row)}
          />
        );
      },
    },
  ];

  const routeColumnsMobile = [
    {
      width: width * 22,
      headerAlign: 'center',
      align: 'center',
      field: 'CODE',
      renderHeader: (params) => <div>Route ID</div>,
    },
    {
      width: width * 50,
      headerAlign: 'center',
      align: 'left',
      field: 'STATION_NAME',
      renderHeader: (params) => <div>Route Name</div>,
    },
    {
      width: width * 23,
      headerAlign: 'center',
      align: 'center',
      field: '',
      renderHeader: () => <div>Select</div>,
      renderCell: (params) => {
        return (
          <input
            type="checkbox"
            checked={selectedRows.some(
              (row) => Number(row.CODE) === Number(params.row.CODE)
            )}
            onChange={(event) => handleCheckboxChange(event, params.row)}
          />
        );
      },
    },
  ];

  const routeColumnsTab = [
    {
      width: width * 15,
      headerAlign: 'center',
      align: 'center',
      field: 'CODE',
      renderHeader: (params) => <div>Route ID</div>,
    },
    {
      width: width * 25,
      headerAlign: 'center',
      align: 'left',
      field: 'STATION_NAME',
      renderHeader: (params) => <div>Route Name</div>,
    },
    {
      width: width * 15,
      headerAlign: 'center',
      align: 'center',
      field: '',
      renderHeader: () => <div>Select</div>,
      renderCell: (params) => {
        return (
          <input
            type="checkbox"
            checked={selectedRows.some(
              (row) => Number(row.CODE) === Number(params.row.CODE)
            )}
            onChange={(event) => handleCheckboxChange(event, params.row)}
          />
        );
      },
    },
  ];

  const routeColumnsTabVerticle = [
    {
      width: width * 15,
      headerAlign: 'center',
      align: 'center',
      field: 'CODE',
      renderHeader: (params) => <div>Route ID</div>,
    },
    {
      width: width * 25,
      headerAlign: 'center',
      align: 'left',
      field: 'STATION_NAME',
      renderHeader: (params) => <div>Route Name</div>,
    },
    {
      width: width * 15,
      headerAlign: 'center',
      align: 'center',
      field: '',
      renderHeader: () => <div>Select</div>,
      renderCell: (params) => {
        return (
          <input
            type="checkbox"
            checked={selectedRows.some(
              (row) => Number(row.CODE) === Number(params.row.CODE)
            )}
            onChange={(event) => handleCheckboxChange(event, params.row)}
          />
        );
      },
    },
  ];

  const getAllPartyPrice = async () => {
    deleteWholeDatabase('Party_Balance_Report');
    setIsRendered(true)
    const data = {
      table_prefix: prefix,
      SID: stationId,
      FDATE: window.innerWidth > 1280 ? date : fromDate,
      TDATE: window.innerWidth > 1280 ? date1 : toDate,
    };
    dispatch(setSpinnerLoading('Loading'));
    CallAPIPromise(
      '/api/reports/allPartyBalance',

      data,
      token,
      dispatch
    )
      .then((p) => {
        setLoading(false);
        const data = p.data.response;
        console.log(data);
        let list = [];
        if (data[0]) {
          for (let i = 0; i < data.length; i++) {
            const v =
              Number(data[i].OP_DEBIT) -
              Number(data[i].OP_CREDIT) +
              Number(data[i].PRV_DEBIT) -
              Number(data[i].PRV_CREDIT);
            list.push({
              ...data[i],
              OP_BALANCE: v > 0 ? v : '',
              balance:data[i].CLOSING_BALANCE
            });
          }
          console.log(list);
          dataToLocal('Party_Balance_Report', list, [
            {
              SID: stationId,
              ICODE: 1,
              FDATE: window.innerWidth > 1280 ? date : fromDate,
              TDATE: window.innerWidth > 1280 ? date1 : toDate,
            },
          ]);
        }

        setRows(list);
      })
      .catch((error) => {
        console.log(error);

        if (error.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  const getStationIDDetails = async () => {
    setLoading(true);
    try {
      CallAPIPromise(
        '/api/listStationMaster/listStationMaster',
        {
          table_prefix: prefix,
          CODE: '',
        },
        token,
        dispatch
      )
        .then((p) => {
          if (p.data?.response[0]) {
            setRouteRows(p.data.response);
            setLoading(false);
            dispatch(setStationList(p.data.response));
          }
        })
        .catch((error) => {
          console.log(error);

          if (error.response.data.name === 'TokenExpiredError') {
            dispatch(setSessionExpired(true));
          }
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!routeRows[0]) {
      getStationIDDetails();
    }
  }, []);

  const okButton = () => {
    getAllPartyPrice();
  };
  useEffect(() => {
    if (isRenderd) {
      getAllPartyPrice()
    }
  },[checked])
  useEffect(() => {
    const callback = (details, data) => {
      setRows(data);
      setstationId(details[0].SID);
    };
    const elseFunc = () => {};
    IsLocalData('Party_Balance_Report', callback, elseFunc);
  }, []);

  const [searchQuery, setSearchQuery] = useState();
  const [filterData, setFilterData] = useState([]);

  const Filter = () => {
    const filteredparty = rows.filter((f) => {
      return f.NAME.toLowerCase().includes(searchQuery.toLowerCase());
    });
    setFilterData(filteredparty);
  };

  useEffect(() => {
    const onHandleChange = () => {
      if (searchQuery) {
        Filter();
      }
    };
    onHandleChange();
  }, [searchQuery]);

  const [searchRoute, setSearchRoute] = useState('');
  const [filterRouteData, setFilterRouteData] = useState([]);

  const FilterRoute = () => {
    const filteredStationName = routeRows.filter((f) => {
      return f.STATION_NAME.toLowerCase().includes(searchRoute.toLowerCase());
    });
    setFilterRouteData(filteredStationName);
  };

  const FilterRouteCode = () => {
    const filteredStationId = routeRows.filter((f) => {
      return f.CODE.toString().includes(searchRoute);
    });
    setFilterRouteData(filteredStationId);
  };

  useEffect(() => {
    const onHandleChangeRoute = () => {
      if (isNaN(searchRoute)) {
        FilterRoute();
      } else {
        FilterRouteCode();
      }
    };
    onHandleChangeRoute();
  }, [searchRoute]);

  const handleCheckboxChange = (event, row) => {
    if (usertype !== 'USER') {
      const selectedRowIds = new Set(
        selectedRows.map((selectedRow) => selectedRow.CODE)
      );
      if (event.target.checked) {
        selectedRowIds.add(row.CODE);
      } else {
        selectedRowIds.delete(row.CODE);
      }
      const selectRowData = routeRows.filter((row) =>
        selectedRowIds.has(row.CODE)
      );

      setSelectedRows(selectRowData);
      dispatch(setPartyBalSelectedRowData(selectRowData));

      const inputRouteName = selectRowData.map((row) => row.STATION_NAME);
      setStName(inputRouteName);
      dispatch(setpartyBalStationName(inputRouteName));
      const inputRouteID = selectRowData.map((row) => row.CODE);
      const selectedStationIdList = inputRouteID.toString();
      dispatch(setPartyBalStationList(selectedStationIdList));
      setstationId(selectedStationIdList);
    } else {
      dispatch(
        setAlertWithTitle({
          title: 'Alert',
          msg: 'No permission to change station',
        })
      );
    }
  };

  const [toggle, setToggle] = useState(false);

  const handleClick = () => {
    setToggle(!toggle);
  };

  const toggleStyle = {
    width: '22px',
    height: '2px',
    backgroundColor: '#424242',
    margin: '3px 0',
    borderRadius: '3px',
  };

  const OpeningBal = rows.reduce(
    (total, row) => Number(total) + Number(row.OP_BALANCE),
    0
  );
  const sumDebit = rows.reduce(
    (total, row) => Number(total) + Number(row.DEBIT),
    0
  );

  const sumCredit = rows.reduce(
    (total, row) => Number(total) + Number(row.CREDIT),
    0
  );

  const netBalance = rows.reduce(
    (total, row) => Number(total) + Number(row.balance),
    0
  );
  const selectedRouteLabel = Array.isArray(stname)
    ? stname.flat().filter(Boolean).join(', ')
    : stname || '';

  return (
    <>
      <div
        id="container"
        className="h-full w-full overflow-auto bg-slate-50 p-2 sm:p-3"
      >
        <section className="mb-2 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
          <div className="flex flex-col gap-2 px-4 py-3 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex items-start gap-3">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-amber-100 text-amber-700">
                <CircleDollarSign size={19} />
              </div>
              <div>
                <h1 className="text-lg font-bold tracking-tight text-slate-900">
                  Party Balance Report
                </h1>
                <p className="text-xs text-slate-500">
                  Review party dues, collections, balances and credit limits.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-1.5 text-xs text-slate-600">
              <MapPin size={16} className="text-slate-400" />
              <span className="text-slate-500">Routes:</span>
              <span className="max-w-[260px] truncate font-semibold text-slate-800">
                {selectedRouteLabel || 'No route selected'}
              </span>
            </div>
          </div>
        </section>

        <section className="mb-2 grid grid-cols-2 gap-2 xl:grid-cols-4">
          {[
            { label: 'Parties', value: rows.length, icon: Users, tone: 'bg-slate-100 text-slate-600' },
            { label: 'Routes selected', value: selectedRows.length, icon: MapPin, tone: 'bg-blue-50 text-blue-600' },
            { label: 'Late payments', value: rows.filter((row) => Number(row.PAYMENT_LATE_BY_DAYS) > 0).length, icon: ReceiptIndianRupee, tone: 'bg-rose-50 text-rose-600' },
            { label: 'Net balance', value: FormatNumber2(netBalance), icon: Landmark, tone: 'bg-amber-50 text-amber-700' },
          ].map(({ label, value, icon: Icon, tone }) => (
            <div key={label} className="rounded-lg border border-slate-200 bg-white px-3 py-2 shadow-sm">
              <div className="flex items-center gap-2.5">
                <div className={`flex h-8 w-8 items-center justify-center rounded-md ${tone}`}>
                  <Icon size={16} />
                </div>
                <div className="min-w-0">
                  <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">{label}</p>
                  <p className="truncate text-lg font-bold leading-5 text-slate-900">{value}</p>
                </div>
              </div>
            </div>
          ))}
        </section>
        {toggle && (
          <>
            <div style={{ width: '100%' }}>
              <div
                style={{
                  backgroundColor: 'rgb(56,53,53)',
                  width: '99.7%',
                  height: '40px',
                }}
                className="xl:hidden mt-1 text-white flex font-semibold items-center px-3"
              >
                <div style={{ width: '90%' }}>
                  <p>Select Route</p>
                </div>
                <div
                  style={{ width: '10%' }}
                  className="max-sm:pl-2 t:pl-10 l:pl-16 "
                >
                  <i
                    onClick={() => {
                      setToggle(!toggle);
                    }}
                    style={{
                      fontSize: '25px',
                      color: 'white',
                      display: 'flex',
                    }}
                    className="bi bi-x-circle"
                  ></i>
                </div>
              </div>
              <div
                className="xl:hidden ml-2"
                style={
                  window.innerWidth <= 500
                    ? {
                        width: '96%',
                        height: '450px',
                        position: 'absolute',
                        top: '20%',
                      }
                    : window.innerWidth <= 768
                    ? {
                        width: '55%',
                        height: '600px',
                        position: 'absolute',
                        top: '16%',
                      }
                    : {
                        width: '55%',
                        height: '400px',
                        position: 'absolute',
                        top: '22%',
                      }
                }
              >
                <ReportDataTable
                  columns={
                    window.innerWidth <= 500
                      ? routeColumnsMobile
                      : window.innerWidth <= 768
                      ? routeColumnsTabVerticle
                      : routeColumnsTab
                  }
                  rows={
                    filterRouteData.length > 0 ? filterRouteData : routeRows
                  }
                  loading={loading}
                  getRowKey={(row) => row.CODE}
                  emptyTitle="No routes found"
                  emptyDescription="Search another route or refresh the route list."
                />
                <div
                  style={{
                    width: '100%',
                    height: '40px',
                    borderRadius: '7px',
                    border: '1px solid #b5b3b3',
                  }}
                  className="mt-2"
                >
                  <input
                    value={searchRoute}
                    onChange={(e) => {
                      setSearchRoute(e.target.value);
                      setFilterRouteData('');
                    }}
                    style={{ borderRadius: '7px' }}
                    type="search"
                    className="h-full w-full focus:outline-none px-2 text-xs"
                    placeholder="Search Route"
                  ></input>
                </div>
                <div
                  style={{
                    width: '100%',
                    height: '40px',
                    backgroundColor: 'rgb(56,53,53)',
                    color: 'white',
                    borderRadius: '7px',
                  }}
                  className="mt-2"
                >
                  <button
                    onClick={() => {
                      setToggle(!toggle);
                    }}
                    style={{ width: '100%', height: '100%' }}
                  >
                    Oksss
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
        {!toggle && (
          <div className="flex w-full xl:hidden">
            <div
              id="body"
              style={
                window.innerWidth <= 768
                  ? { width: '100%', color: '#424242' }
                  : window.innerWidth <= 1024
                  ? { width: '100%', color: '#424242' }
                  : { width: '100%', color: '#424242' }
              }
            >
              <div
                className="max-sm:block t:flex  p-1 "
                style={{ width: '100%' }}
              >
                <div
                  className="flex p-1"
                  style={
                    window.innerWidth <= 500
                      ? {
                          width: '100%',
                          border: '1px solid #b5b3b3',
                          borderTopLeftRadius: '7px',
                          borderTopRightRadius: '7px',
                          borderBottom: '0px',
                          fontSize: '11px',
                        }
                      : window.innerWidth <= 768
                      ? {
                          width: '60%',
                          border: '1px solid #b5b3b3',
                          borderTopLeftRadius: '7px',
                          borderBottomLeftRadius: '7px',
                        }
                      : window.innerWidth <= 1024
                      ? {
                          width: '50%',
                          border: '1px solid #b5b3b3',
                          borderTopLeftRadius: '7px',
                          borderBottomLeftRadius: '7px',
                        }
                      : {
                          width: '50%',
                          border: '1px solid #b5b3b3',
                          borderTopLeftRadius: '7px',
                          borderBottomLeftRadius: '7px',
                        }
                  }
                >
                  <div
                    style={{ width: '26%' }}
                    className="xl:flex xl:text-lg max-sm:hidden  t:hidden xl:items-center"
                  >
                    From Date
                  </div>
                  <div
                    style={{ width: '18%' }}
                    className="flex justify-center  items-center text-xs  xl:hidden"
                  >
                    From
                  </div>
                  <div className="w-fit">
                    <GeniusReportsDate
                      date={fromDate}
                      onChange={(date) => {
                        setFromDate(moment(date).format('YYYY-MM-DD'));
                        dispatch(
                          setreportsFromDate(moment(date).format('YYYY-MM-DD'))
                        );
                      }}
                      SetDateFocus={setFromDateFocus}
                      dateFocus={fromDateFocus}
                    />
                  </div>

                  <div
                    style={{ width: '15%' }}
                    className="flex justify-center items-center xl:text-lg max-sm:text-xs t:text-xs"
                  >
                    To
                  </div>

                  <div>
                    <GeniusReportsDate
                      date={toDate}
                      onChange={(date) => {
                        setToDate(moment(toDate).format('YYYY-MM-DD'));
                        dispatch(
                          setreportsTodate(moment(date).format('YYYY-MM-DD'))
                        );
                      }}
                      SetDateFocus={setToDateFocus}
                      dateFocus={toDateFocus}
                    />
                  </div>

                  <button
                    style={{
                      fontSize: 14,
                      fontWeight: '500px',
                      display: window.innerWidth <= 768 ? 'none' : 'flex',
                    }}
                    data-tooltip-id="tip"
                    data-tooltip-content="Refresh"
                    className="pl-2"
                  >
                    <i className="bi text-[20px] text-orange bi-arrow-clockwise"></i>
                  </button>
                </div>
                <div
                  className="flex p-1 items-center"
                  style={
                    window.innerWidth <= 500
                      ? {
                          width: '100%',
                          border: '1px solid #b5b3b3',
                        }
                      : window.innerWidth <= 768
                      ? {
                          width: '40%',
                          border: '1px solid #b5b3b3',
                          borderLeft: '0px solid #b5b3b3',
                          borderTopRightRadius: '7px',
                          borderBottomRightRadius: '7px',
                        }
                      : window.innerWidth <= 1024
                      ? {
                          width: '50%',
                          border: '1px solid #b5b3b3',
                          borderLeft: '0px solid #b5b3b3',
                          borderTopRightRadius: '7px',
                          borderBottomRightRadius: '7px',
                        }
                      : {
                          width: '100%',
                          border: '1px solid #b5b3b3',
                        }
                  }
                >
                  <input
                    value={stname}
                    type="text"
                    className="text-xs focus:outline-none p-2 pl-3 mr-2"
                    style={{
                      backgroundColor: '#f5f5f5',
                      width: '95%',
                      borderRadius: '7px',
                    }}
                    placeholder="Route Name"
                    readOnly
                  />
                  <div className="mr-2">
                    <button
                      onClick={okButton}
                      className="flex items-center rounded-sm ml-2"
                      style={{
                        backgroundColor: '#c1c1c1',
                        paddingLeft: 30,
                        paddingRight: 30,
                        paddingTop: 4,
                        paddingBottom: 4,
                        color: 'black',
                      }}
                    >
                      <div className="flex items-center text-sm">Ok</div>
                    </button>
                  </div>
                  <button onClick={handleClick} className="xl:hidden">
                    <div style={toggleStyle}></div>
                    <div style={toggleStyle}></div>
                    <div style={toggleStyle}></div>
                  </button>
                </div>
              </div>
              <div
                className="xl:p-4 xl:pt-0 max-sm:p-2 max-sm:pt-0 t:p-2 t:pt-0"
                style={{ width: '100%' }}
              >
                <ReportDataTable
                  columns={columns}
                  rows={filterData.length > 0 ? filterData : rows}
                  getRowKey={(row) => row.ACCOUNT_NO}
                  emptyTitle="No party balance data found"
                  emptyDescription="Select routes and run the report to view party balances."
                  footerValue={(column) => {
                    if (column.field === 'NAME') return 'Grand Total';
                    if (column.field === 'DEBIT') return FormatNumber2(sumDebit);
                    if (column.field === 'CREDIT') return FormatNumber2(sumCredit);
                    if (column.field === 'balance') return FormatNumber2(netBalance);
                    return '';
                  }}
                />
              </div>

              <div
                className=" flex xl:p-4 xl:pt-0 max-sm:p-2 max-sm:pt-0 t:p-2 t:pt-0"
                style={{ width: '100%' }}
              >
                <div
                  style={
                    window.innerWidth < 500
                      ? {
                          width: '50%',
                          borderRadius: '7px',
                          border: '1px solid #b5b3b3',
                          height: '45px',
                          display: 'flex',
                        }
                      : {
                          width: '80%',
                          borderRadius: '7px',
                          border: '1px solid #b5b3b3',
                          height: '45px',
                          display: 'flex',
                        }
                  }
                >
                  <input
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setFilterData('');
                    }}
                    type="search"
                    className="focus:outline-none pl-3"
                    style={{
                      width: '100%',
                      borderRadius: '7px',
                      height: '100%',
                    }}
                    placeholder="Search Party"
                  />
                </div>
                <div
                  style={
                    window.innerWidth < 500
                      ? {
                          width: '50%',
                          marginLeft: '5px',
                        }
                      : {
                          width: '20%',
                          marginLeft: '5px',
                        }
                  }
                >
                  <ReactToPrint
                    trigger={() => {
                      return (
                        <button
                          style={{
                            width: '100%',
                            borderRadius: '7px',
                            height: '100%',
                            backgroundColor: '#bad4f9',
                            color: 'black',
                          }}
                        >
                          Print Report
                        </button>
                      );
                    }}
                    content={() => printRef.current}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
       
    

        <div className="xl:flex w-full max-sm:hidden t:hidden l:hidden gap-4">
          <div
            style={
              window.innerWidth <= 768
                ? { width: '100%', color: '#424242' }
                : window.innerWidth <= 1024
                ? { width: '100%', color: '#424242' }
                : {
                    width: '80%',
                    color: '#424242',
                  }
            }
            className="overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-sm"
          >
            <div className="flex  " style={{ width: '100%' }}>
              <div
                className="flex items-center rounded-l-lg border border-slate-200 bg-slate-50 p-3 px-3"
                style={{
                  borderTopLeftRadius: '7px',
                  borderBottomLeftRadius: '7px',
                }}
              >
                <div className="xl:flex max-sm:hidden text-[12px]  t:hidden xl:items-center">
                  {window.innerWidth <= 1280 ? 'From' : 'From'}
                </div>
                <div className="   ml-2">
                  <GeniusReportsDate
                    date={date}
                    onChange={(date) => {
                      setDate(moment(date).format('YYYY-MM-DD'));
                      dispatch(
                        setreportsFromDate(moment(date).format('YYYY-MM-DD'))
                      );
                      SetDateFocus(false);
                    }}
                    SetDateFocus={SetDateFocus}
                    dateFocus={dateFocus}
                  />
                </div>

                <div className="flex justify-center items-center mx-4 text-[12px]  ">
                  To
                </div>

                <div>
                  <GeniusReportsDate
                    date={date1}
                    onChange={(date1) => {
                      setDate1(moment(date1).format('YYYY-MM-DD'));
                      dispatch(
                        setreportsTodate(moment(date1).format('YYYY-MM-DD'))
                      );
                      SetDateFocus1(false);
                    }}
                    SetDateFocus={SetDateFocus1}
                    dateFocus={dateFocus1}
                  />
                </div>

                <button
                  style={{
                    fontSize: 14,
                    fontWeight: '500px',
                  }}
                  data-tooltip-id="tip"
                  data-tooltip-content="Refresh"
                  className="pl-2"
                >
                  <i className="bi text-[20px] text-orange bi-arrow-clockwise"></i>
                </button>
              </div>
              <div
                className="flex flex-1 items-center rounded-r-lg border border-l-0 border-slate-200 bg-slate-50 p-1"
                style={{
                  borderTopRightRadius: '7px',
                  borderBottomRightRadius: '7px',
                }}
              >
                <input
                  value={selectedRouteLabel}
                  type="text"
                  className="xl:text-lg t:text:sm max-sm:text-xs l:text-md p-2 focus:outline-none pl-3"
                  style={{
                    backgroundColor: '#f5f5f5',
                    width: '100%',
                    borderRadius: '7px',
                  }}
                  placeholder="Route Name"
                  readOnly
                />
                <div>
                  <button
                    onClick={okButton}
                    className="ml-2 flex h-10 items-center rounded-lg bg-blue-600 px-6 text-sm font-semibold text-white transition hover:bg-blue-700"
                  >
                    Ok
                  </button>
                </div>
                <div>
                  <ReactToPrint
                    trigger={() => {
                      return (
                        <button
                          className="ml-2 h-10 rounded-lg bg-slate-900 px-5 text-sm font-semibold text-white transition hover:bg-slate-700"
                        >
                          Print
                        </button>
                      );
                    }}
                    content={() => printRef.current}
                  />
                </div>
              </div>
            </div>
            <label className="mt-3 flex w-fit cursor-pointer items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 text-sm font-medium text-slate-700">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => setChecked(e.target.checked)}
      />
      <span>Opening Bal.</span>
    </label>
            <div
              className="mt-3"
              style={{ width: '100%' }}
            >
              <ReportDataTable
                columns={columns}
                rows={filterData.length > 0 ? filterData : rows}
                getRowKey={(row) => row.ACCOUNT_NO}
                emptyTitle="No party balance data found"
                emptyDescription="Select routes and run the report to view party balances."
                footerValue={(column) => {
                  if (column.field === 'NAME') return 'Grand Total';
                  if (column.field === 'DEBIT') return FormatNumber2(sumDebit);
                  if (column.field === 'CREDIT') return FormatNumber2(sumCredit);
                  if (column.field === 'balance') return FormatNumber2(netBalance);
                  return '';
                }}
              />
            </div>
            <div className="mt-3" style={{ width: '100%', color: '#424242' }}>
              <div className="relative mt-3 h-11 w-full">
                <Search size={17} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setFilterData('');
                  }}
                  type="search"
                  className="h-full w-full rounded-lg border border-slate-300 pl-10 pr-3 text-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                  style={{
                    width: '100%',
                  }}
                  placeholder="Search party name"
                />
              </div>
            </div>
          </div>
   
          <div className="max-sm:hidden t:hidden l:block h-[690px] flex-1 overflow-hidden rounded-2xl border border-slate-200 bg-white p-3 shadow-sm">
            <div className="mb-2 flex items-center justify-between">
              <h2 className="text-sm font-semibold text-slate-900">Routes</h2>
              <span className="rounded-full bg-slate-100 px-2 py-1 text-xs font-medium text-slate-600">
                {selectedRows.length} selected
              </span>
            </div>
            <div
              style={{
                width: '100%',
                height: `calc(100% - 92px)`,
                borderRadius: '7px',
              }}
            >
              <ReportDataTable
                columns={
                  window.innerWidth <= 1024 ? routeColumnsTab : routeColumns
                }
                rows={filterRouteData.length > 0 ? filterRouteData : routeRows}
                loading={loading}
                getRowKey={(row) => row.CODE}
                emptyTitle="No routes found"
                emptyDescription="Search another route or refresh the route list."
              />
            </div>
            <div
              style={{
                width: '100%',
                height: '45px',
                borderRadius: '7px',
                border: '1px solid #b5b3b3',
              }}
              className="mt-2"
            >
              <input
                value={searchRoute}
                onChange={(e) => {
                  setSearchRoute(e.target.value);
                  setFilterRouteData('');
                }}
                style={{ borderRadius: '7px' }}
                type="search"
                className="h-full w-full rounded-lg border border-slate-300 px-3 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                placeholder="Search route"
              ></input>
            </div>
          </div>
        </div>

        {printRef && windowSize ? (
          <div
            ref={printRef}
            className="hidden w-full print:block"
          >
            <PrintPartyBalanceReport
              date={date}
              date1={date1}
              data={rows}
              // data={balanceData}
              stationId={stationId}
              sum={OpeningBal}
              sumDebit={sumDebit}
              sumCredit={sumCredit}
              sumBalance={netBalance}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default PartyBalanceReport;
